import { Navigate } from 'react-router-dom';
import { ROUTE_PATHS } from './constants';
import AdminLayoutContent from '../layouts/AdminLayout';
import AdminGuard from './guards/adminGuard';
import AdminDashboard from '../containers/adminDashboard';
import Users from '../containers/users';
import KnowledgeBase from '../containers/knowledgeBase';

const adminRoutes = {
  path: '/admin',
  element: (
    <AdminGuard>
      <AdminLayoutContent />
    </AdminGuard>
  ),
  children: [
    {
      path: '',
      element: <AdminDashboard />,
    },
    {
      path: 'users',
      element: <Users />,
    },
    {
      path: 'knowledge-base',
      element: <KnowledgeBase />,
    },

    {
      path: '*',
      element: <Navigate to={ROUTE_PATHS.PORTAL} />,
    },
  ],
};

export default adminRoutes;